import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tooltip} from 'kpc';
import {Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$refs = this.refs;
    var _$ref___test = function(i) {_$refs['__test'] = i};
    
    return _$ce(2, 'div', (
        _$cc(Tooltip, {
            'content': '确定删除？',
            'confirm': true,
            'theme': 'light',
            'trigger': 'click',
            'ev-ok': this.ok,
            'ev-cancel': this.cancel,
            'ref': _$ref___test,
            'children': (
                _$cc(Button, {
                    'children': '删除'
                })
            )
        }, null, _$ref___test)
    ), 2);
};